import { useState, useEffect } from 'react';

export const useIsMobile = (breakpoint: number = 768): boolean => {
    const [isMobile, setIsMobile] = useState<boolean>(() => {
        if (typeof window === 'undefined') {
            return false;
        }

        return window.innerWidth < breakpoint;
    });

    useEffect(() => {
        const checkIsMobile = (): void => {
            setIsMobile(window.innerWidth < breakpoint);
        };

        const mediaQuery = window.matchMedia(`(min-width: ${breakpoint}px)`);

        checkIsMobile();

        const handleChange = (e: MediaQueryListEvent): void => {
            setIsMobile(!e.matches);
        };

        mediaQuery.addEventListener('change', handleChange);
        window.addEventListener('resize', checkIsMobile);

        return () => {
            mediaQuery.removeEventListener('change', handleChange);
            window.removeEventListener('resize', checkIsMobile);
        };
    }, [breakpoint]);

    return isMobile;
};
